import { Badge } from '@/components/ui/badge';

interface DiscountBadgeProps {
  discountPercentage: number;
  className?: string;
  size?: 'sm' | 'default' | 'lg';
}

export const DiscountBadge: React.FC<DiscountBadgeProps> = ({ 
  discountPercentage, 
  className = "",
  size = "default"
}) => {
  if (discountPercentage <= 0) return null;

  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    default: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5"
  };

  return (
    <Badge 
      variant="destructive" 
      className={`
        bg-gradient-to-r from-red-500 to-red-600 
        text-white font-bold 
        border-none shadow-md
        animate-pulse
        ${sizeClasses[size]} 
        ${className}
      `}
    >
      -{discountPercentage}%
    </Badge>
  );
};